import { Badge } from '../catalyst/badge';

const statusMap = {
  'on track': {
    color: 'green',
    text: 'Calling',
  },
  slipping: {
    color: 'red',
    text: 'Slipping',
  },
  upside: {
    color: 'amber',
    text: 'Upside',
  },
  closed: {
    color: 'sky',
    text: 'Closed',
  },
  completed: {
    color: 'green',
    text: 'Completed',
  },
  scheduled: {
    color: 'blue',
    text: 'Scheduled',
  },
  late: {
    color: 'red',
    text: 'Late',
  },
  ongoing: {
    color: 'sky',
    text: 'Ongoing',
  },
};

export default function StatusBadge({ status }) {
  const settings = statusMap[status?.toLowerCase()];
  const { color, text } = settings || { color: 'grey', text: 'unknown' };
  return <Badge color={color || 'grey'}>{text || status}</Badge>;
}
